import $ from 'jquery';

export default () => {
  // TODO: Add support for nav animations

  // Add support for loading indicator on submit button
  $('form')
    .not('.no-loader')
    .on('submit', displayFormLoader);
};

function displayFormLoader(event) {
  const $button = $(document.activeElement);
  if (!$button.hasClass('no-loader')) {
    $button.addClass('loading');
  }

  return true;
}

export const hideFormLoader = $form => {
  $form.find('button.loading').removeClass('loading');
};



// WEBPACK FOOTER //
// ./src/plugins/loader.js